import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCartContext } from '../../context/CartContext';
import { CartPreviewUI } from './CartPreviewUI';
import { GtmService } from "../../../infrastructure/analytics/GtmService";
import { useParkCart } from '../../application/useParkCart';
import { useUserContext } from '../../../user/infrastructure/UserContext';
import { useComercialContext } from '../../../comercial/ComercialContext';
import { useDownloadQuote } from '../../application/useDownloadQuote';
import { DownloadableQuote } from '../quote/DownloadableQuote';
import { ContainerPDF } from '../../../ui';


export function CartPreview({ setModalCar }) {
  const { cart, loading, loadCart, removeProduct, loadCartBis } = useCartContext();
  const user = useUserContext();
  const { parkCart, parking } = useParkCart(loadCartBis);
  const { actingAsCliente } = useComercialContext();
  const { quoteRef, downloadQuote, downloading: downloadingQuote } = useDownloadQuote();
  const navigate = useNavigate();
  // Presupuesto en PDF: solo un comercial actuando por un cliente (los precios del
  // carrito son los de ese cliente, que es lo que el presupuesto tiene que reflejar)
  const canDownloadQuote = user?.isComercial === true && !!actingAsCliente;

  useEffect(() => {
    loadCart();
  }, [loadCart]);

  const navigateTo = (path) => {
    navigate(path);
    setModalCar(null);
  }

  const handlePlaceOrder = () => {
    GtmService.logBeginCheckout(cart);
    navigateTo('/checkout');
  }

  return (
    <>
      <CartPreviewUI cart={cart}
        loading={loading}
        onCatalogClick={() => navigateTo('/articulos')}
        onEditProduct={(product) => navigateTo(`/articulos/${encodeURIComponent(product.code)}`)}
        onDeleteProduct={(product) => removeProduct(product)}
        onPlaceOrder={handlePlaceOrder}
        onParkCart={user?.isComercial === true ? parkCart : undefined}
        parking={parking}
        onDownloadQuote={canDownloadQuote ? () => downloadQuote(actingAsCliente.numCliente) : undefined}
        downloadingQuote={downloadingQuote}
      />
      {canDownloadQuote && (
        <ContainerPDF ref={quoteRef}>
          <DownloadableQuote cart={cart} cliente={actingAsCliente} comercialCode={user?.code} />
        </ContainerPDF>
      )}
    </>
  );
}